<template>
    <v-autocomplete
        :items="data"
        :loading="loading"
        v-bind="$props"
        item-text="name"
        item-value="id"
        @focus="handleFocus"
        @change="$emit('change', $event)"
        @input="$emit('input', $event)">
    </v-autocomplete>
</template>

<script>
import { getTruckTypes } from './../services/truckType';
export default {
    name: "TruckTypeAutocomplete",
    props: {
        dense: Boolean,
        label: String,
        outlined: Boolean,
        backgroundColor: String,
        hideDetails: [String, Boolean],
        value: [String, Number]
    },
    data() {
        return {
            data: [],
            loading: false
        }
    },
    methods: {
        async fetchData() {
            this.loading = true;
            let resp = await getTruckTypes();
            this.data = resp.data;
            this.loading = false;
        },
        handleFocus() {
            this.fetchData();
        }
    },
    created() {
        this.fetchData();
    }
}
</script>

<style>

</style>